import Cookie from 'common/services/util/-RFC.Cookie';

/**
* @ngdoc service
* @name notifications.ActionNotifications
*
* @description
* This class is used to process action notifications.
*/
const ActionNotifications = {

    /**
     * @ngdoc function
     * @name notifications.ActionNotifications#processUpdate
     * @methodOf notifications.ActionNotifications
     * @function
     *
     * @description
     * This function can be used to process updates made on actions.
     *
     * @param {object} data An object with updated values on action.
     * @param {object} prevAction The old action object.
     * @param {object} currentAction The update action object.
     */

    processUpdate(data, prevAction, currentAction) {

        const actionType = currentAction.attributes.action_type;

        // Logout user
        if (actionType === 'logout') {

            const cookieConfig = CWCONFIG.cookie;
            const { domain, rootDomain } = cookieConfig;

            // Remove loginType cookie
            Cookie.remove(cookieConfig.loginType, {
                path: '/',
                domain,
            });

            // Remove login cookies
            Cookie.remove(cookieConfig.token, {
                path: '/',
                domain,
            });

            Cookie.remove(cookieConfig.refreshToken, {
                path: '/',
                domain,
            });

            Cookie.remove(cookieConfig.token, {
                path: '/',
                domain: rootDomain,
            });

            Cookie.remove(cookieConfig.refreshToken, {
                path: '/',
                domain: rootDomain,
            });

            // Remove SSO cookies
            // get all cookies
            const cookies = document.cookie;
            // regex to match all sso keys
            // example: prod_launcher_sso or prod_launcher_refresh_sso
            const regex = new RegExp(`^(${CWCONFIG.cookie.ssoToken}[a-z]+[_a-z]*?_sso)`, 'g');
            cookies.split('; ').map((cookie) => {

                // check if cookie matches the regex
                const match = cookie.match(regex);
                if (match) {

                    Cookie.remove(match[0], {
                        path: '/',
                        domain,
                    });

                    Cookie.remove(match[0], {
                        path: '/',
                        domain: rootDomain,
                    });

                }

                return '';

            });

            // wait for location path to be changed firefox/safari bug
            setTimeout(() => {

                window.location.reload();
                window.location.href = '/en/auth/login';

            }, 0);

        }

    },

};

export default ActionNotifications;



// WEBPACK FOOTER //
// ./scripts/common/notifications/-RFC.actionNotifications.js